/**
 * Google Maps
 *
 */

import {Loader} from 'google-maps';
import axios from 'axios';

export default function Maps() {

	let map;
	let markers = [];
	let	mapItem = document.querySelector('.js-academy-map');
	let contactMapItem = document.querySelector('.js-contact-map');
	let infoWindows = [];
	let bounds;
	let postcode;

	if (mapItem) {
		initialize();
		search();
		setTimeout(() => {
			setMarkers();
		}, 1000);
	}

	if (contactMapItem) {
		initializeContactMap();
	}


	function initializeContactMap() {
		let apiKey = process.env.MIX_GOOGLE_MAPS_API;
		let loader = new Loader(apiKey);

		let lng = parseFloat(contactMapItem.dataset.lng);
		let lat = parseFloat(contactMapItem.dataset.lat);

		// Run the map once the loader has loaded
		loader.load().then((google) => {
			map = new google.maps.Map(contactMapItem, {
				center: new google.maps.LatLng(lat, lng),
				zoom: 13,
				mapTypeControl: false
			});

			let marker = new google.maps.Marker({
				position: {lat, lng},
				map,
				icon: {
					url: '/icons/location.svg',
					scaledSize: new google.maps.Size(40, 40)
				}
			});

			marker.setMap(map);
		});
	}
	function initialize() {
		let apiKey = process.env.MIX_GOOGLE_MAPS_API;
		let loader = new Loader(apiKey);

		// Run the map once the loader has loaded
		loader.load().then((google) => {

			map = new google.maps.Map(mapItem, {
				center: new google.maps.LatLng(52.6128717, -1.1911363),
				zoom: 7,
				mapTypeControl: false
			});

			let custom_address = document.querySelector('.js-custom-address-trigger');
			if (custom_address) {
				custom_address.addEventListener('click', function () {
					let custom_value = document.querySelector('.js-custom-address-value');

					if (custom_value.value) {
						update(custom_value.value);
					}
				});
			}

			let academy_zooms = document.querySelectorAll('.js-academy-zoom');

			if (academy_zooms) {
				academy_zooms.forEach(function (zoom) {
					zoom.addEventListener('click', function () {
						let lat = parseFloat(zoom.dataset.lat);
						let lng = parseFloat(zoom.dataset.lng);
						let latlng = {lat, lng};

						map.setCenter(latlng);
						map.setZoom(15);
					});
				});
			}

			google.maps.event.addDomListener(window, 'resize', function() {
				map.fitBounds(bounds);
			});
		});
	}

	function setMarkers() {
		bounds = new google.maps.LatLngBounds();
		let locations = JSON.parse(mapItem.dataset.locations.replace(/&quot;/g, '"'));

		locations.forEach(function (location) {
			let latlng = {lat: parseFloat(location.lat), lng: parseFloat(location.lng)}
			let marker = new google.maps.Marker({
				position: latlng,
				map,
				title: 'Test title',
				content: 'Test content',
				// content: '<div style="padding: 20px; padding-top: 10px; padding-left: 10px; text-align: center;"><div class="u-font-bold u-font-colour-primary">' + location.provider + '</div></div>'
				icon: {
					url: '/icons/location.svg',
					scaledSize: new google.maps.Size(40, 40)
				}
			});

			let infowindow = new google.maps.InfoWindow();

			google.maps.event.addListener(marker, 'click', function () {
				infowindow.setContent(this.content);
				infowindow.open(map, this);
			});

			markers.push(marker);
			infoWindows.push(infowindow);
			bounds.extend(latlng);
		});

		map.fitBounds(bounds);

	}

	function removeMarkers() {
		markers.forEach(function(marker) {
			marker.setMap(null);
		});

		setMarkers();
	}

	function update(postcode) {

		removeMarkers();

		postcode = postcode.replace(' ', '');

		axios.post(`/api/location/?data=${postcode}`)
			.then(function(response) {
				let data = response.data;

				let latlng = { lat: parseFloat(data.lat), lng: parseFloat(data.lng) }

				let marker = new google.maps.Marker({
					position: latlng,
					map,
					title: 'Your Location',
					icon: {
						url: '/icons/home.svg',
						scaledSize: new google.maps.Size(40, 40)
					}
				});

				markers.push(marker);
				bounds.extend(latlng);
				map.fitBounds(bounds);
			});
	}

	function search() {
		//on keyup of input .js-academy-search-trigger
		let search = document.querySelector('.js-academy-search-trigger');

		if (search) {
			let searchables = document.querySelectorAll('.js-searchable-academies li');

			if (searchables.length > 0) {
				search.addEventListener('keyup', function () {
					let search_value = search.value;

					if (search_value.length > 2) {
						searchables.forEach(function (searchable) {
							let searchable_text = searchable.textContent.toLowerCase();
							let search_value = search.value.toLowerCase();

							if (searchable_text.includes(search_value)) {
								searchable.style.display = 'block';
							} else {
								searchable.style.display = 'none';
							}
						});
					} else {
						searchables.forEach(function (searchable) {
							searchable.style.display = 'block';
						});
					}
				});
			}
		}
	}
}
